module.exports = __webpack_public_path__ + "static/media/Aquarius-Regular.620afa1e.ttf";